// extracted by mini-css-extract-plugin
export var aircallIframe = "_fp-3";
export var fabContainer = "_fp-5";
export var fabRinging = "_fp-6";
export var loadingOverlay = "_fp-4";
export var pulse = "_fp-7";
export var widgetContent = "_fp-2";
export var widgetPanel = "_fp-0";
export var widgetPanelExpanded = "_fp-1";